import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Creates a debounced function that delays invoking func until after wait milliseconds
 * have elapsed since the last time the debounced function was invoked.
 */
export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeout: NodeJS.Timeout | null = null

  return (...args: Parameters<T>) => {
    if (timeout) {
      clearTimeout(timeout)
    }

    timeout = setTimeout(() => {
      func(...args)
    }, wait)
  }
}
/** Format a gram value with comma thousands separator, e.g. 19935.0 → "19,935.0g" */
export function formatGrams(value: number | string | null | undefined, decimals = 1): string {
  if (value == null) return '—';
  const n = Number(value);
  if (isNaN(n)) return '—';
  return n.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) + 'g';
}


/** Format a weight in pounds with comma thousands separator, e.g. 1234.5 → "1,234.5 lbs" */
export function formatLbs(value: number | string | null | undefined, decimals = 1): string {
  if (value == null) return '—';
  const n = Number(value);
  if (isNaN(n)) return '—';
  return n.toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) + " lbs";
}
